import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { FinanceService } from '../../../finance/finance.service';

@Component({
    selector: 'app-add-purchase-order',
    templateUrl: './add-purchase-order.component.html',
    styleUrls: ['./add-purchase-order.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddPurchaseOrderComponent implements OnInit {

	@Input() comment: any;
	@Input() element: any;
	@Input() type: string;
	@Output() closeView = new EventEmitter<any>();
	@Output() notify = new EventEmitter<any>();

	loading: boolean = false;
	values: any = {
		'id': '',
		'purchase_order': ''
	}

	close() {
		this.closeView.emit()
	}

	submitForm() {
		this.loading = true;
		if (this.type == 'service') {
			this._fiS.addServicePurchaseOrder(this.values).subscribe(
				(data: any) => {
					this.notify.emit();
					this.loading = false;
				}
			);
		} else if (this.type == 'catering') {
			this._fiS.addDataCatering(this.values.id, this.values.purchase_order, 1).subscribe(
				(data: any) => {
					this.notify.emit();
					this.loading = false;
				}
			)
		}
	}

	fillForm() {
		this.values.purchase_order = this.element.po ? this.element.po : '';
		this.values.id = this.element.id;
	}

	constructor(private _fiS: FinanceService) { }

	ngOnInit() {
		this.fillForm();
	}

}
